export const SEGMENTS_LIST = "SEGMENTS_LIST"
export const SEGMENTS_LIST_SUCCESS = "SEGMENTS_LIST_SUCCESS"
export const SEGMENTS_LIST_ERROR = "SEGMENTS_LIST_ERROR"

export const SEGMENTS_NEW = "SEGMENTS_NEW"
export const SEGMENTS_NEW_SUCCESS = "SEGMENTS_NEW_SUCCESS"
export const SEGMENTS_NEW_ERROR = "SEGMENTS_NEW_ERROR"

export const SEGMENTS_EDIT = "SEGMENTS_EDIT"

export const SEGMENTS_DELETE = "SEGMENTS_DELETE"
export const SEGMENTS_DELETE_SUCCESS = "SEGMENTS_DELETE_SUCCESS"
export const SEGMENTS_DELETE_ERROR = "SEGMENTS_DELETE_ERROR"
